const ContactorState = {
  OPEN: 'open',
  CLOSED: 'closed',
}

export default ContactorState
